import { Label } from 'reactstrap';
import { selectThemeColors } from '@utils';
import Select from 'react-select';
import { Controller } from 'react-hook-form';
import classNames from 'classnames';

const CustomSelect = ({
  id,
  name,
  label,
  control,
  options,
  loading,
  error,
  bottom
}) => {
  return (
    <div className={classNames('form-group', bottom ? 'mb-0' : 'mb-3')}>
      {label && <Label for={id}>{label}</Label>}

      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Select
            {...field}
            theme={selectThemeColors}
            isClearable={false}
            className={classNames('react-select', {
              'is-invalid': !!error
            })}
            classNamePrefix="select"
            isLoading={loading}
            options={options}
            value={options.find((item) => item.value === field.value)}
            onChange={(e) => {
              field.onChange(e.value);
            }}
          />
        )}
      />
      {error && (
        <span className="text-danger">
          <small>{error.message}</small>
        </span>
      )}
    </div>
  );
};

export default CustomSelect;
